import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../announcements";

export const FETCH_DELETE_ANNOUNCEMENTS_REQUEST = 'FETCH_DELETE_ANNOUNCEMENTS_REQUEST';
export const FETCH_DELETE_ANNOUNCEMENTS_SUCCESS = 'FETCH_DELETE_ANNOUNCEMENTS_SUCCESS';
export const FETCH_DELETE_ANNOUNCEMENTS_FAILURE = 'FETCH_DELETE_ANNOUNCEMENTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteAnnouncementsRequest = () => {
    return {
        type: FETCH_DELETE_ANNOUNCEMENTS_REQUEST,
    };
};

const fetchDeleteAnnouncementsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_ANNOUNCEMENTS_SUCCESS,
        payload: data
    };
};

const fetchDeleteAnnouncementsFailure = (error: any) => {
    return {
        type: FETCH_DELETE_ANNOUNCEMENTS_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteAnnouncementsRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteAnnouncementsSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteAnnouncementsFailure(error.message));
        }
    };
};
